import { manageResearchAreas } from '../../../../../img/images';
import { InstructionTickIcon } from '../../../../shared/icons/icons';
import { ILocalization } from '../../../../../localization/definitions/types';

interface Props {
    localization: ILocalization;
}

export const ManageResearchAreaSlideImage = () => {
    return (
        <div className='carousel-img w-100 h-100'>
            <div className='student-more-time-slide'>
                <img alt='' src={manageResearchAreas} />
            </div>
        </div>
    );
};

export const ManageResearchAreaSlideImageSrc = manageResearchAreas;

export const ManageResearchAreaSlideContent = ({ localization }: Props) => {
    const { manageResearchAreaSlide } =
        localization.localizationStrings.susy.thesisManagement.tutorial
            .supervisor.slides;

    return (
        <div className='tutorial-content-wrapper'>
            <h1>{manageResearchAreaSlide.createAndEdit}</h1>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {manageResearchAreaSlide.nameAndDesc}{' '}
                    <span className='instruction-content-bold'>
                        {manageResearchAreaSlide.researchAreas}
                    </span>{' '}
                    ​
                </div>
            </div>

            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {manageResearchAreaSlide.defineKeywords}​
                </div>
            </div>
        </div>
    );
};
